<ng-container *ngIf="cardData">
  <div class="card_wrapper card_wrapper-flexed">
    <div class="activity_bankInformation">
      <img
        class="activity_bankInformation-logo"
        *ngIf="cardData?.bankLogo"
        [src]="cardData.bankLogo"
        [alt]="cardData.bankName"
      />
    </div>
    <div class="activity_bankInfo_wrapper">
      <div class="activity_bankInformation_text-block">
        <p
          *ngIf="cardData?.offer?.offerResponse?.terms?.loanAmount"
          class="activity_bankInformation__kredit_sum"
        >
          {{
            cardData?.offer?.offerResponse?.terms?.loanAmount?.toLocaleString(
              "de-DE",
              { minimumFractionDigits: 0 }
            )
          }}
          € Kreditsumme
        </p>
        <p *ngIf="cardData?.offer?.offerResponse?.terms?.duration">
          {{ cardData?.offer?.offerResponse?.terms?.duration | period }}
          Laufzeit
        </p>
      </div>
      <div class="activity_bankInformation__rate_wrapper">
        <p
          *ngIf="cardData.offer.offerResponse.terms?.monthlyInstallment"
          class="activity_bankInformation__amount"
        >
          <ngContent
            *ngIf="cardData.offer.offerResponse.terms.goodMonthlyInstallment"
            >{{
              currencyFormatter(
                cardData.offer.offerResponse.terms.goodMonthlyInstallment
              )
            }}
            -</ngContent
          >
          {{
            currencyFormatter(
              cardData.offer.offerResponse.terms?.monthlyInstallment
            )
          }}
        </p>
        <p
          class="activity_bankInformation__text"
          *ngIf="
            cardData?.offer?.offerResponse?.terms?.monthlyInstallment ||
            cardData?.offer?.offerResponse?.terms?.goodMonthlyInstallment
          "
        >
          <span
            *ngIf="
              cardData.offer.contractStateFlow !==
              Offer.ContractStateFlowEnum.Preliminary
            "
            >monatliche Rate</span
          >
          <span
            *ngIf="
              cardData.offer.contractStateFlow ===
              Offer.ContractStateFlowEnum.Preliminary
            "
            >voraussichtliche mtl. Rate</span
          >
        </p>
      </div>
    </div>
  </div>
  <div
    class="applicant_wrapper"
    *ngIf="cardData.offer.bankApplication.applicants.twoApplicants"
  >
    <div
      [ngClass]="['applicant_name', activeApplicant === 0 ? 'active' : '']"
      (click)="handleApplicantChange(0)"
    >
      {{ cardData.offer.bankApplication.applicants.holder }}
    </div>
    <div
      [ngClass]="['applicant_name', activeApplicant === 1 ? 'active' : '']"
      (click)="handleApplicantChange(1)"
    >
      {{ cardData.offer.bankApplication.applicants.secondApplicantName }}
    </div>
  </div>
  <div
    *ngIf="
      cardData.closingTrackProgress[0].pageName !== 'No progression available'
    "
    class="card_wrapper"
  >
    <div class="flex justify-between align-center">
      <h1 class="card_wrapper_title">Ihr Antrag</h1>
      <p class="contract_number">Antragsnummer: {{ cardData.offer.id }}</p>
    </div>
    <div class="flex">
      <div class="flex-1">
        <app-offer-progress
          [progression]="cardData.closingTrackProgress[activeApplicant]"
        />
      </div>
      <div class="closing-track-button">
        <button
          class="rate__button"
          (click)="
            onClosingTrack(
              getToken(),
              cardData.offer.offerResponse?.terms?.loanAmount
            )
          "
          *ngIf="
            cardData.offer.contractState === 'NEW' ||
            cardData.offer.contractState === 'PRELIMINARY_OFFER' ||
            cardData.offer.contractState === 'PRELIMINARY_ACCEPTED' ||
            cardData.offer.contractState === 'ACCEPTED' ||
            cardData.offer.contractState === 'IDENT_STARTED' ||
            (cardData.offer.contractStateFlow == 'DEFAULT' &&
              cardData.offer.contractState === 'IDENT_FINISHED') ||
            cardData.offer.contractState === 'DOCUMENTS_MISSING' ||
            cardData.offer.contractState === 'DOCUMENTS_MISSING_2ND' ||
            (cardData.offer.contractState === 'CLOSING_FINISHED' &&
              cardData.offer.bankProduct.bankDetails.bankGateway ===
                'NOVUMBANK')
          "
        >
          <span
            *ngIf="
              (cardData.offer.contractStateFlow !== 'PRELIMINARY' &&
                (cardData.offer.contractState === 'NEW' ||
                  cardData.offer.contractState === 'ACCEPTED')) ||
              ((cardData.offer.contractStateFlow === 'PRELIMINARY' ||
                cardData.offer.contractStateFlow === 'CLICKOUT') &&
                cardData.offer.contractState === 'PRELIMINARY_ACCEPTED' &&
                cardData.offer.bankProduct.bankDetails.bankGateway !==
                  'OBERBANK') ||
              (cardData.offer.contractStateFlow === 'CLICKOUT' &&
                cardData.offer.contractState === 'PRELIMINARY_OFFER') ||
              (cardData.offer.contractStateFlow === 'DEFAULT' &&
                cardData.offer.contractState === 'PRELIMINARY_ACCEPTED' &&
                cardData.offer.bankProduct.bankDetails.bankGateway === 'BANK99')
            "
            >zum Kreditabschluss</span
          >
          <span
            *ngIf="
              cardData.offer.contractStateFlow === 'PRELIMINARY' &&
              cardData.offer.contractState === 'PRELIMINARY_ACCEPTED' &&
              cardData.offer.bankProduct.bankDetails.bankGateway == 'OBERBANK'
            "
            >zur Terminvereinbarung</span
          >
          <span *ngIf="cardData.offer.contractState === 'IDENT_STARTED'"
            >zur Videotelefonie</span
          >
          <span
            *ngIf="
              (cardData.offer.contractStateFlow === 'PRELIMINARY' &&
                cardData.offer.contractState === 'PRELIMINARY_OFFER') ||
              (cardData.offer.contractStateFlow !== 'PRELIMINARY' &&
                cardData.offer.contractState === 'IDENT_FINISHED')
            "
            >zum Dokumentenupload</span
          >
          <span
            *ngIf="
              cardData.offer.contractState === 'DOCUMENTS_MISSING' ||
              cardData.offer.contractState === 'DOCUMENTS_MISSING_2ND'
            "
            >Unterlagen nachreichen</span
          >
          <span
            *ngIf="
              (cardData.offer.contractState === 'CLOSING_FINISHED' &&
                cardData.offer.bankProduct.bankDetails.bankGateway ===
                  'NOVUMBANK') ||
              (cardData.offer.contractStateFlow === 'DEFAULT' &&
                cardData.offer.contractState === 'PRELIMINARY_ACCEPTED' &&
                cardData.offer.bankProduct.bankDetails.bankGateway !== 'BANK99')
            "
            >weiter</span
          >
        </button>
        <p
          class="rate__text"
          *ngIf="
            cardData.offer.contractState === 'REJECTED' ||
            cardData.offer.contractState === 'DOCUMENTS_UPLOADED' ||
            cardData.offer.contractState === 'DOCUMENTS_UPLOADED_2ND' ||
            cardData.offer.contractState === 'DOCUMENTS_CHECKED' ||
            cardData.offer.contractState === 'DOCUMENTS_CHECKED_2ND' ||
            cardData.offer.contractState === 'REJECTED_2ND' ||
            (cardData.offer.contractStateFlow == 'PRELIMINARY' &&
              cardData.offer.contractState === 'IDENT_FINISHED') ||
            cardData.offer.contractState === 'REJECTED_CLEARING' ||
            (cardData.offer.contractState === 'CLOSING_FINISHED' &&
              cardData.offer.bankProduct.bankDetails.bankGateway !==
                'NOVUMBANK') ||
            cardData.offer.contractState === 'CLOSED'
          "
        >
          <b
            class="icon-warning"
            *ngIf="
              cardData.offer.contractState === 'REJECTED' ||
              cardData.offer.contractState === 'REJECTED_2ND' ||
              cardData.offer.contractState === 'REJECTED_CLEARING'
            "
            >!</b
          >
          <svg
            *ngIf="
              cardData.offer.contractState === 'DOCUMENTS_UPLOADED' ||
              (cardData.offer.contractState === 'CLOSING_FINISHED' &&
                cardData.offer.bankProduct.bankDetails.bankGateway !==
                  'NOVUMBANK') ||
              (cardData.offer.contractStateFlow === 'PRELIMINARY' &&
                cardData.offer.contractState === 'IDENT_FINISHED')
            "
            class="icon-clock"
            version="1.2"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            overflow="visible"
            preserveAspectRatio="none"
            viewBox="0 0 34 34"
            height="32"
            width="32"
          >
            <g transform="translate(1, 1)">
              <title>clock</title>
              <path
                d="M16.352 14.464v-6.048h-1.28v6.144c-0.32 0.256-0.672 0.736-0.672 1.28 0 0.832 0.704 1.472 1.536 1.472 0.608 0 1.12-0.256 1.376-0.896h5.44v-1.28h-5.504c-0.16-0.32-0.576-0.544-0.896-0.672z"
                fill="#444"
                vector-effect="non-scaling-stroke"
              />
              <path
                d="M31.744 19.36c0.224-1.088 0.32-2.272 0.32-3.456 0-0.512-0.032-1.024-0.064-1.536-0.832-8.064-7.648-14.368-15.968-14.368-8.864 0-16.032 7.168-16.032 16.032 0 7.424 5.024 13.664 11.872 15.488 1.312 0.32 2.656 0.48 4.096 0.48 1.984 0 3.84-0.32 5.536-0.864 5.152-1.888 9.088-6.304 10.24-11.776zM16.352 28.896v-3.2h-1.28v3.168c-6.72-0.416-11.744-5.728-12.032-12.448h2.752v-1.28h-2.72c0.448-6.4 5.6-11.68 12-12.096v2.816h1.28v-2.816c6.72 0.288 12.096 5.376 12.544 12.096h-3.264v1.28h3.264c-0.288 6.72-5.504 12.16-12.544 12.48z"
                fill="#444"
                vector-effect="non-scaling-stroke"
              />
            </g>
          </svg>
          <b
            class="icon-ok"
            *ngIf="
              cardData.offer.contractState === 'DOCUMENTS_CHECKED' ||
              cardData.offer.contractState === 'CLOSED'
            "
          ></b>
          <span
            *ngIf="
              cardData.offer.contractState === 'REJECTED' ||
              cardData.offer.contractState === 'REJECTED_2ND' ||
              cardData.offer.contractState === 'REJECTED_CLEARING'
            "
            >abgelehnt</span
          >
          <span
            *ngIf="
              cardData.offer.contractStateFlow === 'PRELIMINARY' &&
              cardData.offer.contractState === 'IDENT_FINISHED'
            "
            >Vertrag wird an Bank übermittelt</span
          >
          <span
            *ngIf="
              cardData.offer.contractState === 'DOCUMENTS_UPLOADED' ||
              cardData.offer.contractState === 'DOCUMENTS_UPLOADED_2ND'
            "
            >Dokumente werden geprüft</span
          >
          <span
            *ngIf="
              cardData.offer.contractState === 'DOCUMENTS_CHECKED' ||
              cardData.offer.contractState === 'DOCUMENTS_CHECKED_2ND'
            "
            >Dokumente werden geprüft</span
          >
          <span
            *ngIf="
              cardData.offer.contractState === 'CLOSING_FINISHED' &&
              cardData.offer.bankProduct.bankDetails.bankGateway !== 'NOVUMBANK'
            "
            >Kreditauszahlung wird geprüft</span
          >
          <span *ngIf="cardData.offer.contractState === 'CLOSED'"
            >Kredit wird ausbezahlt</span
          >
        </p>
      </div>
    </div>
  </div>
  <div class="card_wrapper">
    <h1 class="card_wrapper_title">Vertragsdaten</h1>

    <div class="contract_data-row">
      <p>Kreditnehmer</p>
      <p>
        {{
          cardData.offer.bankApplication.applicants.applicants[activeApplicant]
            .person.firstName
        }}
        {{
          cardData.offer.bankApplication.applicants.applicants[activeApplicant]
            .person.lastName
        }}
      </p>
    </div>
    <div class="contract_data-row">
      <p>Antragsnummer</p>
      <p>{{ cardData.offer.id }}</p>
    </div>
    <div class="contract_data-row">
      <p style="padding-right: 10px">Verwendungszweck</p>
      <p class="truncate">{{ getCardData().purpose.name }}</p>
    </div>
    <div class="contract_data-row" *ngIf="isKreditInsurance">
      <p style="padding-right: 10px">Kreditschutz</p>
      <p class="kreditInsuranceInfo">
        <ng-container
          *ngIf="
            kreditInsuranceDetails?.pricePerMonth &&
            !isKreditInsuranceStateCancelled
          "
        >
          {{ kreditInsuranceDetails.name }} -
          {{ currencyFormatter(kreditInsuranceDetails.pricePerMonth) }} / Monat
          <a
            *ngIf="choosenPackageId"
            class="normal-link"
            (click)="openKreditInsuranceDialog()"
          >
            stornieren</a
          >
        </ng-container>
        <span *ngIf="!isKreditInsuranceStateCancelled && !choosenPackageId"
          >nicht vorhanden
          <a
            *ngIf="isContinueWithout"
            class="normal-link"
            (click)="getKreditInsuranceClosingtrackUrl()"
          >
            hinzufügen</a
          ></span
        >

        <span
          *ngIf="isKreditInsuranceStateCancelled && isDeductionStateCancelled"
          >Storno erfolgreich</span
        >
        <span
          *ngIf="isKreditInsuranceStateCancelled && !isDeductionStateCancelled"
          >Storno beauftragt</span
        >
      </p>
    </div>
  </div>
  <div
    data-page="activity_page"
    class="offer_card-details"
    *ngIf="getCardData().offerResponse"
  >
    <div class="details__header">
      <div class="header__title--wrap">
        <button
          class="header__title"
          [class.active]="activated === 0"
          (click)="switchDetails(0)"
        >
          Produkt
        </button>
        <div class="header__title-line"></div>
      </div>
      <div class="header__title--wrap">
        <button
          class="header__title"
          [class.active]="activated === 1"
          (click)="switchDetails(1)"
        >
          Konditionen
        </button>
        <div class="header__title-line"></div>
      </div>
      <div class="header__title--wrap">
        <button
          class="header__title"
          [class.active]="activated === 2"
          (click)="switchDetails(2)"
        >
          Nachweise
        </button>
        <div class="header__title-line"></div>
      </div>
    </div>
    <div class="details__content">
      <app-product
        *ngIf="activated === 0"
        [productData]="getCardData()"
      ></app-product>
      <app-conditions
        *ngIf="activated === 1"
        [fullWidth]="true"
        [conditionsData]="getCardData()"
      ></app-conditions>
      <app-proof
        *ngIf="activated === 2"
        [proofData]="getCardData()"
      ></app-proof>
    </div>
  </div>
  <div class="card_wrapper">
    <h1 class="card_wrapper_title">Dokumente</h1>
    <div
      *ngIf="cardData.offer.contractToken"
      class="contract-icon-wrapper"
      (click)="getContractDownload()"
    >
      <svg-icon
        src="/resultpage/assets/icons/PDF.svg"
        className="pdfIcon"
        aria-hidden="true"
      ></svg-icon>
      <p>Kreditvertrag</p>
    </div>
    <div
      class="contract-icon-wrapper"
      (click)="getReminderMailAttachment('Erstinformation')"
      *ngIf="isKreditInsurance && kreditInsuranceDetails?.name"
    >
      <svg-icon
        src="/resultpage/assets/icons/PDF.svg"
        className="pdfIcon"
        aria-hidden="true"
      ></svg-icon>
      <p>Erstinformation</p>
    </div>
    <div
      class="contract-icon-wrapper"
      (click)="getReminderMailAttachment('Einkommensschutz24_Dokumente')"
      *ngIf="isKreditInsurance && kreditInsuranceDetails?.name"
    >
      <svg-icon
        src="/resultpage/assets/icons/PDF.svg"
        className="pdfIcon"
        aria-hidden="true"
      ></svg-icon>
      <p>Einkommensschutz24 Dokumente</p>
    </div>
    <p *ngIf="!cardData.offer.contractToken">Kreditvertrag nicht verfügbar</p>
  </div>
  <app-sales-agent-box [offerId]="cardData?.offer?.id"></app-sales-agent-box>
</ng-container>
<div class="loginPopup" *ngIf="loginService.loginPopup">
  <unified-login
    api_product="atfinkre"
    init="load"
    [attr.set_login_data]="true"
    [attr.anonymous]="false"
    [attr.base_path]="loginService.basePath"
    [attr.force_login]="true"
    [attr.browserback]="'none'"
    login_email=""
    login_phone=""
    context="as"
    points="none"
    password_reset_type="tan"
    password_reset_ref=""
    social_login_closing_url=""
    social_login_callback_url=""
    set_login_data="true"
  >
  </unified-login>
</div>

<!-- Kredit Insurance Dialog Content -->
<ng-template #kreditInsuranceDialogContent>
  <div class="kredit-insurance-dialog-content">
    <h2>Sind Sie sicher, dass Sie den Kreditschutz stornieren möchten?</h2>
    <p>
      Der Kreditschutz bietet Ihnen finanzielle Sicherheit bei
      Zahlungsausfällen. Mit der Stornierung verzichten Sie auf diese
      Absicherung.
    </p>
    <h3>Möchten Sie den Kreditschutz wirklich stornieren?</h3>
  </div>
</ng-template>

<!-- Actions template - now contains the buttons -->
<ng-template #kreditInsuranceDialogActions let-close="close">
  <div class="kredit-insurance-dialog-actions">
    <button class="dialog-button dialog-button--secondary" (click)="close()">
      abbrechen
    </button>
    <button
      class="dialog-button dialog-button--primary"
      (click)="confirmKreditInsuranceCancellation(); close()"
    >
      jetzt stornieren
    </button>
  </div>
</ng-template>
